import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tournament-report',
  templateUrl: './tournament-report.component.html',
  styleUrls: ['./tournament-report.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class TournamentReportComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private lastTableLazyLoadEvent: LazyLoadEvent;
  loading: boolean;
  paginationOption;
  minYear = environment.minYear;
  submitted: boolean = false;
  rsubmitted: boolean = false;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  downloadFlg: boolean = false;
  startDate: any;
  endDate: any;
  searchby: any;
  searchBy: { label: string; value: string; }[];
  calvalue: null;
  ucalvalue: null;
  errorMessage: any;
  tournamentReportData: any = [];
  tournament: any = [];
  totalRecords: any = 0;
  name: string = "";
  statename: string = "";
  cityname: string = "";
  playerCount: string = "";
  categoryCount: string = "";

  constructor(private tournamentService: TournamentsService) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: "Tournament Start Date", value: "startdate" }
    ];
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.name = "";
    this.dt.filter("", "name", "contains");
    this.dt.filter("", "statename", "contains");
    this.dt.filter("", "cityname", "contains");
    this.dt.filter("", "playerCount", "contains");
    this.dt.filter("", "categoryCount", "contains");
    this.dt.filter("", "start_date", "dateIs");
    this.calvalue = null;
    this.statename = "";
    this.cityname = "";
    this.playerCount = "";
    this.categoryCount = "";
  }

  exportExcel() {
    this.downloadFlg = true;
    this.tournamentReportList(this.lastTableLazyLoadEvent);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  tournamentReportList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["name"] != undefined) {
      params += "&filterByName=" + event.filters["name"].value;
    }
    if (event.filters != undefined && event.filters["statename"] != undefined) {
      params += "&filterByStateName=" + event.filters["statename"].value;
    }
    if (event.filters != undefined && event.filters["cityname"] != undefined) {
      params += "&filterByCityName=" + event.filters["cityname"].value;
    }
    if (event.filters != undefined && event.filters["playerCount"] != undefined) {
      params += "&filterByPlayerCount=" + event.filters["playerCount"].value;
    }
    if (event.filters != undefined && event.filters["categoryCount"] != undefined) {
      params += "&filterByCategoryCount=" + event.filters["categoryCount"].value;
    }
    if (event.filters != undefined && event.filters["start_date"] != undefined) {
      const start_date = moment(event.filters["start_date"].value).format("YYYY-MM-DD");
      params += "&filterByStart_date=" + start_date;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.tournamentService.generateTournamentReport(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.loading = false;
        if (this.downloadFlg === true) {
          this.tournamentReport(data.data.items);
        } else {
          this.tournament = data.data.items;
          this.totalRecords = data.data.totalCount;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  tournamentReport(data) {
    this.loading = false;
    this.tournamentReportData = data;
    var downloadTournamentReport = this.tournamentReportData;
    let tournamentReportData = [];
    downloadTournamentReport.forEach(function (item) {
      tournamentReportData.push({
        "_id": item.id,
        "name": item.name,
        "startdate": item.startdate,
        "statename": item.statename,
        "cityname": item.cityname,
        "playerCount": item.playerCount,
        "categoryCount": item.categoryCount,
      });

    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(tournamentReportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, `TournamentReport`);
    });
    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}